module.exports = __webpack_public_path__ + "media/assets/images/share-a1316eb22cbe5be5c31e26a3ddbc6e5d.svg";